'use strict';

import functions from './functions.es6.js';
import variables from './variables.es6.js';

export default {
  functions,
  variables
};
